import {
  IconArrowRight,
  GreyGrey60,
  GreyGrey80,
  Primary13Regular,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { format } from '@sequencehq/utils/dates'

const styles = {
  primary: {
    color: GreyGrey80,
    ...Primary13SemiBold
  },
  secondary: {
    color: GreyGrey60,
    ...Primary13Regular
  }
}

export const RenderPhaseDates = (props: {
  startDate: Date
  endDate?: Date
  theme: 'primary' | 'secondary'
}) => {
  const style = styles[props.theme ?? 'primary']

  if (!props.endDate || props.startDate > props.endDate) {
    return <Box {...style}>{format(props.startDate, 'd LLLL yyyy')}</Box>
  }

  return (
    <Flex
      alignItems="center"
      gap="4px"
      {...style}
      data-testid="reviewPricing.phase.dates"
    >
      <Box>{format(props.startDate, 'd LLLL yyyy')}</Box>
      <IconArrowRight color="inherit" />
      <Box>{format(props.endDate, 'd LLLL yyyy')}</Box>
    </Flex>
  )
}
